import { render, staticRenderFns } from "./ExpandableInputEdit.vue?vue&type=template&id=c08b3818&"
import script from "./ExpandableInputEdit.vue?vue&type=script&lang=ts&"
export * from "./ExpandableInputEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports